import React from 'react';
import { Button } from '../UI/Button';
import { Link } from 'react-router-dom';
interface FinalCTAProps {
  openPaymentForm?: () => void;
  scrollToAccessPoints?: () => void;
}
export const FinalCTA = ({
  openPaymentForm,
  scrollToAccessPoints
}: FinalCTAProps) => {
  return <section className="py-20 bg-gray-50" data-id="element-403">
      <div className="container mx-auto px-4 text-center" data-id="element-404">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 max-w-3xl mx-auto" data-id="element-405">
          Stop Collecting Contacts. Start Building Connections That Change Your
          Future.
        </h2>
        <Button className="text-lg px-8 py-4" onClick={scrollToAccessPoints} data-id="element-406">
          Join Now for ₦20,000 (Founder's Rate)
        </Button>
      </div>
    </section>;
};